<template>
  <div>
    <b-modal v-model="modalActive" width="70%" scroll="keep">
      <div class="card">
        <header class="card-header ">
          <div class="card-header-title is-flex">
            <h6 class="is-size-6 ml-auto mr-auto pl-4 has-text-weight-semibold">{{ title }}</h6>
          </div>
          <b-button class="card-header-icon mt-2 mr-2" aria-label="more options" @click="show(false, false, false)">
            <b-icon icon="close"></b-icon>
          </b-button>
        </header>
        <div class="card-content" :style="isPipelineEditOrAddAllowed(data) ? 'min-height:500px' : 'min-height: 300px'">
          <div class="content" v-if="data">

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Site Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.siteName }}</div>
            </div>

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Device Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.name }}</div>
            </div>

            <div class="mt-3 mb-6">
              <div class="m-0 p-0 pr-0 pl-0">
                <div class="is-size-7 has-text-grey-light mt-1">Pipeline settings</div>
                <div>
                  <div v-if="currentPipeline" class="columns m-0 p-0">
                    <div class="column p-0 m-0">
                      <div class="is-size-7">Ai:</div>
                      <div class="has-text-weight-semibold">{{ currentPipeline.ai }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Data:</div>
                      <div class="has-text-weight-semibold">{{ currentPipeline.data }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Events:</div>
                      <div class="has-text-weight-semibold">{{ currentPipeline.events }}</div>
                    </div>
                  </div>
                  <div v-else class="is-size-6 has-text-weight-normal has-text-warning">Pipeline is not defined</div>
                  <div v-if="currentRules">
                    <div class="mt-3"
                         v-if="currentRules.near_miss">
                      <div class="is-flex">
                        <div class="has-text-weight-semibold mt-2">Nearmiss Rules</div>
                      </div>
                      <hr class="my-divider">
                      <div v-if="currentRules.near_miss.length > 0" class="mt-3">
                        <div v-for="(rule, index) in currentRules.near_miss" :key="index">
                          <div class="columns m-0 p-0 mb-3">
                            <div class="column m-0 p-0">
                              <div class="is-size-7">User Type 1</div>
                              <div>{{ rule.userType1 }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">User Type 2</div>
                              <div>{{ rule.userType2 }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Origin 1</div>
                              <div>{{ rule.origin1 }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Origin 2</div>
                              <div>{{ rule.origin2 }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Stage Name</div>
                              <div>{{ rule.stageName }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3"
                         v-if="currentRules.red_light_compliance">
                      <div class="is-flex">
                        <div class="has-text-weight-semibold mt-2">Red Light Rules</div>
                      </div>
                      <hr class="my-divider">
                      <div v-if="currentRules.red_light_compliance.length > 0" class="mt-3">
                        <div v-for="(rule, index) in currentRules.red_light_compliance" :key="index">
                          <div class="columns m-0 p-0 mb-3">
                            <div class="column m-0 p-0">
                              <div class="is-size-7">Type</div>
                              <div>{{ rule.type }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Stage Name</div>
                              <div>{{ rule.stageName }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Origin</div>
                              <div>{{ rule.origin }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Light ID</div>
                              <div>{{ rule.lightId }}</div>
                            </div>
                            <div class="column m-0 p-0 ml-3">
                              <div class="is-size-7">Light Yellow Offset</div>
                              <div>{{ rule.lightYellowOffset }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="isPipelineEditOrAddAllowed(data)">
                  <div class="mt-6">Edit Processing Pipeline</div>
                  <div class="columns m-0 p-0 is-align-items-center mt-3 mr-3">
                    <div class="column p-0 is-4">
                      <b-field label="Select AI processing requirements" label-position="on-border" expanded>
                        <b-dropdown v-model="newPipeline.ai" multiple aria-role="list" expanded :scrollable="true"
                                    :max-height="200" @input="onAiChanged">
                          <template #trigger>
                            <b-button icon-right="menu-down" expanded>
                              Selected ({{ newPipeline.ai.length }})
                            </b-button>
                          </template>

                          <b-dropdown-item v-for="option in aiOptions" :value="option"
                                           :disabled="(option === 'lyra' && newPipeline.ai.includes('yolo')) || (option === 'yolo' && newPipeline.ai.includes('lyra'))"
                                           :key="option" aria-role="listitem">
                            <span>{{ option }}</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-field>

                    </div>
                    <div class="column p-0 is-4 ml-3">
                      <b-field label="Select Data requirements" label-position="on-border" expanded>
                        <b-dropdown v-model="newPipeline.data"
                                    :multiple="newPipeline && newPipeline.ai && newPipeline.ai.includes('lyra')"
                                    aria-role="list" expanded :scrollable="true"
                                    :max-height="200" @input="onDataChanged" :disabled="isStepDisabled()">
                          <template #trigger>
                            <b-button icon-right="menu-down" expanded>
                              Selected ({{ newPipeline.data.toString() }})
                            </b-button>
                          </template>

                          <b-dropdown-item v-for="option in dataOptions" :value="option"
                                           :disabled="(option === 'vela_with_lyra' && newPipeline.ai.includes('yolo')) || (option === 'vela_with_yolo' && newPipeline.ai.includes('lyra'))"
                                           :key="option" aria-role="listitem">
                            <span>{{ option }}</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-field>
                    </div>
                    <div class="column p-0 is-4 ml-3 mr-3">
                      <!--                      <b-field label="Select event requirements" label-position="on-border" expanded>
                                              <b-select placeholder="Select event requirements..." v-model="newPipeline.events" required expanded
                                                        :disabled="isStepDisabled()">
                                                <option
                                                    v-for="option in eventsOptions"
                                                    :value="option"
                                                    :key="option">
                                                  {{ option }}
                                                </option>
                                              </b-select>
                                            </b-field>-->
                      <b-field label="Select event requirements" label-position="on-border" expanded>
                        <b-dropdown v-model="newPipeline.events" :multiple="true" aria-role="list" expanded
                                    :scrollable="true"
                                    :max-height="200" :disabled="isStepDisabled()" @input="onEventsChanged">
                          <template #trigger>
                            <b-button icon-right="menu-down" expanded>
                              Selected ({{ newPipeline.events.toString() }})
                            </b-button>
                          </template>

                          <b-dropdown-item v-for="option in eventsOptions" :value="option"
                                           :disabled="(option === 'red_light_compliance' && (newPipeline.ai.includes('yolo') || newPipeline.ai.includes('lyra')) && !newPipeline.ai.includes('traffic-light'))"
                                           :key="option" aria-role="listitem">
                            <span>{{ option }}</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-field>
                    </div>
                  </div>

                  <div class="mt-3"
                       v-if="newPipeline && newPipeline.events && newPipeline.events.includes('near_miss')">
                    <div class="is-flex">
                      <div class="has-text-weight-semibold mt-2">Nearmiss Rules</div>
                      <a v-on:click.stop @click="onAddRule('near_miss')" class="m-2 ml-auto">
                        <b-icon icon="plus-circle">
                        </b-icon>
                      </a>
                    </div>
                    <hr class="my-divider">
                    <div
                        v-if="newPipeline.rules && newPipeline.rules.near_miss && newPipeline.rules.near_miss.length > 0"
                        class="mt-3">
                      <div v-for="(rule, index) in newPipeline.rules.near_miss" :key="index">
                        <div class="columns m-0 p-0 mb-3">
                          <div class="column m-0 p-0">
                            <b-field label="User Type 1" label-position="on-border">
                              <b-select placeholder="Select User Type 1..." v-model="rule.userType1" expanded>
                                <option
                                    v-for="option in userOptions"
                                    :value="option"
                                    :key="option">
                                  {{ option }}
                                </option>
                              </b-select>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="User Type 2" label-position="on-border">
                              <b-select placeholder="Select User Type 2..." v-model="rule.userType2" expanded>
                                <option
                                    v-for="option in userOptions"
                                    :value="option"
                                    :key="option">
                                  {{ option }}
                                </option>
                              </b-select>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Origin 1" label-position="on-border">
                              <b-input expanded placeholder="Origin 1"
                                       v-model="rule.origin1"
                                       type="text" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Origin 2" label-position="on-border">
                              <b-input expanded placeholder="Origin 2"
                                       v-model="rule.origin2"
                                       type="text" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Stage Name" label-position="on-border">
                              <b-input expanded placeholder="Stage Name"
                                       v-model="rule.stageName"
                                       type="text"></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 is-flex" style="max-width: 64px">
                            <a v-on:click.stop @click="removeRule('near_miss', index)" class="ml-auto"
                               style="margin-right: 16px;margin-top: 8px;">
                              <b-icon icon="minus-circle" type="is-danger">
                              </b-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3"
                       v-if="newPipeline && newPipeline.events && newPipeline.events.includes('red_light_compliance')">
                    <div class="is-flex">
                      <div class="has-text-weight-semibold mt-2">Red Light Rules</div>
                      <a v-on:click.stop @click="onAddRule('red_light_compliance')" class="m-2 ml-auto">
                        <b-icon icon="plus-circle">
                        </b-icon>
                      </a>
                    </div>
                    <hr class="my-divider">
                    <div
                        v-if="newPipeline.rules && newPipeline.rules.red_light_compliance && newPipeline.rules.red_light_compliance.length > 0"
                        class="mt-3">
                      <div v-for="(rule, index) in newPipeline.rules.red_light_compliance" :key="index">
                        <div class="columns m-0 p-0 mb-3">
                          <div class="column m-0 p-0">
                            <b-field label="Type" label-position="on-border">
                              <b-select placeholder="Select Type..." v-model="rule.type" expanded>
                                <option
                                    v-for="option in userOptions"
                                    :value="option"
                                    :key="option">
                                  {{ option }}
                                </option>
                              </b-select>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Stage Name" label-position="on-border">
                              <b-input expanded placeholder="Stage Name"
                                       v-model="rule.stageName"
                                       type="text" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Origin" label-position="on-border">
                              <b-input expanded placeholder="Origin"
                                       v-model="rule.origin"
                                       type="text" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Light Id" label-position="on-border">
                              <b-input expanded placeholder="Light Id"
                                       v-model="rule.lightId"
                                       type="text" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 ml-3">
                            <b-field label="Light Yellow Offset" label-position="on-border">
                              <b-input expanded placeholder="Light Yellow Offset"
                                       v-model.number="rule.lightYellowOffset"
                                       type="number" step=".01" required></b-input>
                            </b-field>
                          </div>
                          <div class="column m-0 p-0 is-flex" style="max-width: 64px">
                            <a v-on:click.stop @click="removeRule('red_light_compliance', index)" class="ml-auto"
                               style="margin-right: 16px;margin-top: 8px;">
                              <b-icon icon="minus-circle" type="is-danger">
                              </b-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer" v-if="isPipelineEditOrAddAllowed(data)">
          <b-button class="is-primary is-fullwidth m-2" @click="onSaveClicked" rounded :disabled="!canSave()">Save
            Pipeline
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {isPipelineEditOrAddAllowed} from "@/utils/helper";

export default {
  name: "create-pipeline-modal",
  components: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      data: null,
      title: null,
      infoType: null,
      currentPipeline: null,
      currentRules: null,
      aiOptions: ["lyra", "yolo", "traffic-light", "seacliff", "motorcycle"],
      dataOptions: ["vela_with_lyra", "vela_with_yolo"],
      eventsOptions: ['near_miss', 'dtp', 'red_light_compliance'],
      userOptions: ['Vehicle', 'Pedestrian'],
      newPipeline: {
        ai: null, //["lyra", "traffic-light", "seacliff"],
        data: null, // [ "vela"],
        events: null, //["ca"|'dtp']
        rules: null
      }
    }
  },
  mounted() {
  },
  methods: {
    isPipelineEditOrAddAllowed,
    show(show, data, title) {
      console.log('On show choose modal data: ', data)
      this.processingPeriods = []
      this.data = data
      this.title = title
      this.currentPipeline = this.data && this.data.dataRequired ? this.data.dataRequired : null
      this.currentRules = this.data && this.data.dataRequired && this.data.dataRequired.rules ? this.data.dataRequired.rules : null
      if (this.currentPipeline) {
        this.newPipeline = JSON.parse(JSON.stringify(this.currentPipeline))
      } else {
        this.newPipeline = {
          ai: [],
          data: [],
          events: [],
          rules: null
        }
      }
      this.modalActive = show

      console.log('New pipeline: ', this.newPipeline)
      console.log('Current rules: ', this.currentRules)
    },
    onAiChanged() {
      this.newPipeline.data = []
      this.newPipeline.events = []
      this.newPipeline.rules = null
    },
    onDataChanged() {
      this.newPipeline.events = []
      this.newPipeline.rules = null
    },
    onEventsChanged(events) {
      console.log('On events changed: ', events)
      if (events && events.length === 0) {
        this.newPipeline.rules = null
      } else if (!events.includes('near_miss') && this.newPipeline.rules && this.newPipeline.rules['near_miss']) {
        delete this.newPipeline.rules['near_miss']
      } else if (!events.includes('red_light_compliance') && this.newPipeline.rules && this.newPipeline.rules['red_light_compliance']) {
        delete this.newPipeline.rules['red_light_compliance']
      }
    },
    onSaveClicked() {
      console.log('On update current model', this.newPipeline)
      if (this.newPipeline.rules) {
        const filtered = Object.fromEntries(
            Object.entries(this.newPipeline.rules).map(([key, arr]) => [
              key,
              arr.filter(obj =>
                  Object.values(obj).some(v => v !== null)
              )
            ])
        );

        this.newPipeline.rules = filtered
      }

      console.log('On save pipeline: ', this.newPipeline)

       this.$emit('onSavePipeline', {dataDeviceId: this.data._id, pipeline: this.newPipeline})
    },
    canSave() {
      return !!(this.newPipeline.ai && this.newPipeline.ai.length > 0 && this.newPipeline.data && this.newPipeline.data.length > 0);
    },
    isStepDisabled() {
      if (this.newPipeline.ai.includes('lyra')) {
        return false
      }
      return !this.newPipeline.ai.includes('yolo');
    },
    onAddRule(eventType) {

      console.log('On add Rules: ', this.newPipeline.rules)

      if (this.newPipeline.rules == null) {
        this.newPipeline.rules = {}
      }

      if (this.newPipeline.rules[eventType] == null) {
        this.newPipeline.rules[eventType] = []
      }

      if (eventType === 'near_miss') {
        this.newPipeline.rules[eventType].push(
            {
              userType1: null,
              userType2: null,
              origin1: null,
              origin2: null,
              stageName: null
            }
        )
      }

      if (eventType === 'red_light_compliance') {
        this.newPipeline.rules[eventType].push(
            {
              type: null,
              stageName: null,
              origin: null,
              lightId: null,
              lightYellowOffset: null //number
            }
        )
      }

      const rules = JSON.parse(JSON.stringify(this.newPipeline.rules))

      this.newPipeline.rules = rules

      console.log('Rules: ', this.newPipeline.rules)
    },
    removeRule(eventType, index) {
      const rules = JSON.parse(JSON.stringify(this.newPipeline.rules))
      rules[eventType].splice(index, 1)
      this.newPipeline.rules = rules
    }
  }
}
</script>

<style scoped lang="scss">
.my-divider {
  border: none;
  border-top: 2px solid #eee;
  margin: 0;
}
</style>